// Form validations are handled differently on content pages; only `#hasFormError`
// needs to be stubbed out (unlike the customer application form which is much
// more complex).
const amountComponentFormValidationToggle = () => {
  return {
    restrict: "E",
    template: require("./template.html"),
    scope: false,
    link: (scope) => {
      scope.isFormValid = true;
      scope.hasFormError = (_form, _input) => !scope.isFormValid;
      scope.toggleFormValidity = () => scope.isFormValid = !scope.isFormValid;
    },
  };
};

angular
  .module("avant.customer_applications.directives")
  .directive("amountComponentFormValidationToggle", amountComponentFormValidationToggle);
